import { images, importAllImages } from '../utils/importImages';
import { NavLink } from "react-router-dom";

import Resume from '../pdf/JinLu-Resume2023.pdf';
//import CompCard from '../pdf/JinLu-CompCard.pdf';
import FilmAndTv from './FilmAndTv';



const MainPage = () => {

  //https://stackoverflow.com/questions/42118296/dynamically-import-images-from-a-directory-using-webpack
  const images = importAllImages(require.context('../images', false, /\.(png|jpe?g|svg)$/));

  return (
    <>
      {/* DOWNLOAD RESUME */}
      <table className="tabledownload">
        <tr style={{ lineHeight: "30px" }}>
          <td>
            <div className="divdownload">
              {/* <p className="pdownload"><small>Download <a href={Resume} className="adownload">resume</a> or <a href={CompCard} className="adownload">comp card</a></small></p> */}
              <p className="pdownload"><small>Download <a href="/comp" className="adownload">comp card</a></small></p>

            </div>
          </td>
        </tr>
      </table>

      {/* HEADER TABLE */}
      <div className="content0">
        <div className="content1">
          <table className="tabledark">
            <colgroup>
              <col width="50%" />
              <col width="50%" />
            </colgroup>
            <tr>
              <td style={{ width: "50%" }}>
                <img width="100%" src={images['head.jpg']} />
              </td>
              <td style={{ width: "50%" }}>
                <div className="divlefthead">
                  <h1>Jin Lu</h1>
                  &nbsp;<br />
                  &nbsp;<br />
                  <big><big><i>Actor</i></big></big>
                  &nbsp;<br />
                  &nbsp;<br />
                  &nbsp;<br />
                  New Zealander <br />
                  Singapore PR<br />
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <table>
                  <colgroup>
                    <col width="10" />
                    <col width="10" />
                    <col className="colshowreel" />
                  </colgroup>
                  <tr>
                    <td style={{ textAlign: "center", padding: "0px" }}>
                      <table className="tableshowreel">
                        <colgroup>
                          <col width="4" />
                          <col width="7" />
                        </colgroup>
                        <tr>
                          <td style={{ textAlign: "end" }}> <img src={images['videocam.svg']} className="imgig" /></td>
                          <td style={{ textAlign: "initial" }}><NavLink to="showreel"><big>Show Reel</big></NavLink></td>
                        </tr>
                      </table>

                    </td>

                    <td style={{ textAlign: "center", padding: "0px" }}>
                      <table className="tableshowreel">
                        <colgroup>
                          <col width="3" />
                          <col width="5" />
                        </colgroup>
                        <tr>
                          <td style={{ textAlign: "end" }}><img src={images['igdark.svg']} className="imgig" /></td>
                          <td style={{ textAlign: "initial" }}><a href="https://instagram.com/jinlu001"><big>@jinlu001</big></a></td>
                        </tr>
                      </table>

                    </td>
                    <td>
                      &nbsp;
                    </td>
                  </tr>

                </table>
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  {/* <span className="material-symbols-outlined">theaters</span> */}
                  <h4>Key Short Films:</h4>
                </p>
                <ul>
                  <li>
                    <a href="./detour">The Detour</a> (Lead)
                  </li>
                  <li>
                    <a href="./lday">Labour Day</a> (Lead)
                  </li>
                  <li>
                    <a href="./bt">Black Thursday</a> (Co-Lead)
                  </li>
                </ul>
                <br />&nbsp;
                <p>
                  {/* <span className="material-symbols-outlined">theaters</span> */}
                  <h4>Key Commercials:</h4>
                </p>
                <ul>
                  <li>
                    <a href="./csa">CSA - The Unseen Enemy</a> (Lead)
                  </li>
                  <li>
                    <a href="./citi">Citibank - Win in Wealth</a> (Lead)

                  </li>

                </ul>
              </td>
              <td>

                <p>
                  <h4>Honours:</h4>
                </p>
                <ul>
                  <li>
                    <big>Best Actor Nomination</big><br />
                    The Detour (Lead)<br />
                    Rio WebFest 2022
                    <br />&nbsp;
                  </li>
                  <li>
                    <big>Official Selections</big><br />
                    Deadline (Lead)<br />
                    <ul>
                      <li>Montecatini Intl Short Film Festival 2023</li>
                      <li>Greece Intl Film Festival 2023</li>
                      <li>Rhode Island Intl Film Festival 2023</li>                    
                    </ul>
                  </li>
                </ul>


              </td>
            </tr>

          </table>
        </div>

      </div>

      {/* PERSONAL DETAILS */}
      <div className="content2">
        <hr />
        <h3>PERSONAL DETAILS</h3>

        <table>
          <colgroup>
            <col width="40%" />
            <col width="60%" />
          </colgroup>
          <tr>
            <td style={{ width: "40%" }}>
              <h4>Contact:</h4>
              <ul>
                <li><a href="tel:+65 9077 6830">+65 9077 6830</a></li>
                <li><a href="mailto:jinluactor@outlook.com">jinluactor@outlook.com</a></li>
              </ul>
            </td>
            <td style={{ width: "60%" }}>
              <img width="100%" src={images['montage.png']} />
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <table>
                <tr>
                  <td style={{ paddingLeft: "0px" }}>
                    <h4>Details:</h4>
                    <ul>
                      <li>
                        43y (screen age)
                      </li>
                      <li>
                        1.79m
                      </li>
                      <li>
                        76kg
                      </li>
                    </ul>
                  </td>
                  <td>
                    <h4>Languages:</h4>
                    <ul>
                      <li>
                        English (Native)
                      </li>
                      <li>
                        Mandarin (Fluent)
                      </li>
                      <li>
                        Cantonese (Intermediate)
                      </li>

                    </ul>
                  </td>
                </tr>

              </table>
            </td>
          </tr>

        </table>
      </div>

      <div className="content2">

        <hr />
        <h3>SKILLS</h3>


        <table>
          <colgroup>
            <col width="50%" />
            <col width="50%" />
          </colgroup>
          <tr>
            <td>
              <h4 className="skills">Martial Arts</h4>
            </td>
            <td>
              <h4 className="skills">Guitar and Vocals</h4>
            </td>

          </tr>
          <tr>
            <td>
              <a href="/martialartsreel">
                <img src={images['fight.link.png']} className="imgthumbskills" />
              </a>
            </td>
            <td>
              <a href="/musicreel">
                <h4>
                  <img src={images['guitar.link.png']} className="imgthumbskills" />
                </h4>
              </a>
            </td>

          </tr>
          <tr>
            <td colspan="1" style={{ textAlign: "center" }}>
              <img width="20" height="19" src={images['link.samsung.png']} />&nbsp;&nbsp;Click images to view media
            </td>
          </tr>

        </table>
        <br />

        {/* FILM */}
        <hr />

        <h3>FILM AND TV EXPERIENCE</h3>

        <table className="experience" cellPadding="0" cellSpacing="0">
          <colgroup>
            <col width="36%" />
            <col width="36%" />
            <col width="28%" />
          </colgroup>
          <tr>
            <td colspan="4">
              <img width="20" height="19" src={images['link.samsung.png']} align="left" />&nbsp;&nbsp;Click images to view media
            </td>
            <td>
              &nbsp;
            </td>
            <td>
              &nbsp;
            </td>
          </tr>
          {/* The Detour */}
          <tr>
            <td>

              <a href="./detour">
                <img src={images['detour.link.png']} className="imgthumb" />
              </a>
            </td>
            <td>
              <h4>The Detour</h4> (Lead)<br />
              Viddsee<br />
              2021
            </td>
            <td>
              <a href="https://riowebfest.net/"><img src={images['rio.link.png']} className="imgrio" /></a><br />
              <big>Best Actor Nomination</big><br />
              <small>
                Rio WebFest 2022
              </small>
            </td>
          </tr>
          <tr style={{ height: "1px" }}><td colspan="3"><hr className="hrblue" /></td></tr>
          {/* Black Thursday */}
          <tr>
            <td>
              <a href="./bt">
                <img src={images['blackthursday.link.png']} className="imgthumb" />
              </a>
            </td>
            <td colspan="1">
              <h4>Black Thursday</h4> (Co-Lead)<br />
              <div style={{ whiteSpace: "nowrap" }}>Channel News Asia</div>
              2024<br />
            </td>
            <td>
              <big>Best Docudrama (Finalist)</big><br />
              <small>
              New York Festivals TV & Film Awards 2025
              </small>
            </td>
          </tr>
          <tr style={{ height: "1px" }}><td colspan="3"><hr className="hrblue" /></td></tr>
          {/* Deadline, Labour Day, Necessity*/}
          <FilmAndTv title="Deadline"   role="Lead" production="Moving Life Pictures" year="2023" festivals={true} separator={true} url="https://filmfreeway.com/TheDeadline703" images={images} image="deadline.link.png"  honour1="montecatini-small.png" honour2="greece.png" honour3="rhode.png" />
          <FilmAndTv title="Labour Day" role="Lead" production="Eyebags Productions"  year="2024" festivals={false} separator={true} url="./lday" images={images} image="labourday.link.png" honour1="river.png"             honour2="greecelday.png"        honour3="" honour1Height={50} honour2Height={70} />
          <FilmAndTv title="Necessity"  role="Lead" production="Moving Life Pictures" year="2024" festivals={true} separator={true} url="https://filmfreeway.com/Necessity157"   images={images} image="necessity.link.png" honour1="montecatini-small.png" honour2="river.png"  honour3="" honour2Height={50} />
          <FilmAndTv title="Shattered Hearts"  role="Co-Lead" production="Green Mango Pictures" year="2023" festivals={false} separator={true} url="./shattered" images={images} image="shattered.Link2.png" />

          {/* Shattered Hearts */}
          {/* <tr>
            <td>
              <a href="https://vimeo.com/932844032">
                <img src={images['shattered.Link2.png']} className="imgthumb" />
              </a>
            </td>
            <td colspan="2">
              <h4>Shattered Hearts</h4> (Lead)<br />
              <div style={{ whiteSpace: "nowrap" }}>Green Mango Pictures</div><br/>
              2023
            </td>
          </tr>
          <tr style={{ height: "1px" }}><td colspan="3"><hr className="hrblue" /></td></tr> */}
          {/* The Gift, Knock Knock */}
          <FilmAndTv title="The Gift"  role="Lead" production="Underground Freedom" year="2020" festivals={false} separator={true} url="./gift"   images={images} image="gift.link.png" honour1="bueiff-bim.png" honour2="bueiff-sel.png"  honour3="cinefest.png" honour1Height={60} honour2Height={65} honour3Height={50} />
          <FilmAndTv title="Knock, Knock"  role="Co-Lead" production="Reverie Films" year="2022" festivals={false} separator={true} url="./knock"   images={images} image="knock.link.png" honour1="" honour2=""  honour3="" />
          {/* Veil */}
          <tr>
            <td>
              <a href="./veil">
                <img src={images['veil.link.png']} className="imgthumb" />
              </a><br />
              <a href="./veil2">
                <img src={images['veil2.link.png']} className="imgthumb" />
              </a>
            </td>
            <td colspan="2">
              <h4>Veil</h4> (Featured)<br />
              MediaCorp<br />
              2022<br />
            </td>
            <td>
            </td>
          </tr>
          <tr style={{ height: "1px" }}><td colspan="3"><hr className="hrblue" /></td></tr>
          {/* 128 Circle, Wastelanders, Knock Knock, Loop */}
          <FilmAndTv title="128 Circle"  role="Featured" production="MediaCorp" year="2021" festivals={false} separator={true} url="./128"   images={images} image="128.link.png" honour1="" honour2=""  honour3="" />
          <FilmAndTv title="Wastelanders"  role="Lead" production="Reverie Films" year="2024" festivals={false} separator={true} url="./waste"   images={images} image="waste.link.png" honour1="" honour2=""  honour3=""  />
          <FilmAndTv title="Loop"  role="Lead" production="Looped Productions" year="2019" festivals={false} separator={false} url="./loop" images={images} image="loop.link.png"  />

        </table>


        {/* COMMERCIALS */}

        <hr />

        <h3>COMMERCIALS</h3>


        <table className="experience" cellPadding="0" cellSpacing="0">
          <colgroup>
            <col width="36%" />
            <col width="40%" />
            <col width="24%" />
          </colgroup>
          <tr>
            <td colspan="2">
              <img width="20" height="19" src={images['link.samsung.png']} align="left" />&nbsp;&nbsp;Click images to view media
            </td>
            <td>
              &nbsp;
            </td>
            <td>
              &nbsp;
            </td>
          </tr>
          <tr>
            <td>
              <a href="./csa">
                <img src={images['csa2.link.png']} className="imgthumb" />
              </a>
            </td>
            <td colspan="2">
              <h4>CSA: The Unseen Enemy</h4> (Lead)<br />
              Smallshop<br />
              2023

            </td>
            <td>
            </td>
          </tr>
          <tr style={{ height: "1px" }}><td colspan="3"><hr className="hrblue" /></td></tr>
          <tr>
            <td>
              <a href="./citi">
                <img src={images['citi.link2.png']} className="imgthumb" />
              </a>
            </td>
            <td colspan="2">
              <h4>Citibank: Win in Wealth</h4> (Lead)<br />
              Smallshop<br />
              2022

            </td>
            <td>
            </td>
          </tr>
          <tr style={{ height: "1px" }}><td colspan="3"><hr className="hrblue" /></td></tr>
          <tr>
            <td>
              <a href="./wf">
                <img src={images['workforce.link.png']} className="imgthumb" />
              </a>
            </td>
            <td colspan="2">
              <h4>Workforce Singapore: VCAI</h4> (Lead)<br />
              OneDash22<br />
              2022

            </td>
            <td>
            </td>

          </tr>
          <tr style={{ height: "1px" }}><td colspan="3"><hr className="hrblue" /></td></tr>
          <tr>
            <td>
              <a href="./sp">
                <img src={images['sp.link.png']} className="imgthumb" />
              </a>
            </td>
            <td colspan="2">
              <h4>SP Group: Corporate Video</h4> (Lead)<br />
              Abundant<br />
              2022
            </td>
            <td>
            </td>

          </tr>
          <tr style={{ height: "1px" }}><td colspan="3"><hr className="hrblue" /></td></tr>
          <tr>
            <td>
              <a href="https://www.instagram.com/p/Ce41g1Vr4CX/?hl=en">
                <img src={images['ig.link.png']} className="imgthumb" />
              </a>
            </td>
            <td colspan="2">
              <h4>IG Asia: Don't Risk It</h4> (Supporting)<br />
              Paradox<br />
              2022
            </td>
            <td>
            </td>
          </tr>

          <tr style={{ height: "1px" }}><td colspan="3"><hr className="hrblue" /></td></tr>
          <tr>
            <td>
              <a href="./mc">
                <img src={images['macs.link.png']} className="imgthumb" />
              </a>
            </td>
            <td colspan="2">
              <h4>McDonald's: Here's to the Fries You Love</h4> (Featured)<br />
              2018
            </td>
            <td>
            </td>
          </tr>
        </table>
        <br />

        {/* ACTING EDUCATION */}
        <hr />
        <h3>ACTING EDUCATION</h3>


        <table className="tableeducation">
          <colgroup>
            <col width="80%" />
            <col width="20%" />
          </colgroup>

          <tr>
            <td colspan="2">
              <h4>Haque Centre of Acting and Creativity</h4>
            </td>
            <td>
            </td>
          </tr>
          <tr>
            <td>
              Lee Strasberg's Method Acting (Intermediate)
            </td>
            <td>
              <big>2021</big>
            </td>
          </tr>
          <tr>
            <td>
              Lee Strasberg's Method Acting (Introduction)
            </td>
            <td>
              <big>2019</big>
            </td>
          </tr>
          <tr>
            <td>
              Fundamentals of Acting on Camera Workshop
            </td>
            <td>
              <big>2019</big>
            </td>
          </tr>
          <tr>
            <td>
              Fundamentals of Acting Workshop
            </td>
            <td>
              <big>2019</big>
            </td>
          </tr>


        </table>

        <br />&nbsp;
        <br />&nbsp;
        <br />&nbsp;
        <br />&nbsp;

      </div>

      {/* FOOTER */}
      <table className="tablefooter">
        <tr>
          <td>
            Jin Lu - Actor<br />
            <a href="mailto:jinluactor@outlook.com">jinluactor@outlook.com</a><br />
          </td>
        </tr>
      </table>

    </ >
  );
};

export default MainPage;
